import type { JSX } from "react";
import { Row, Stack, Text, Icon } from "../../components/ui";
import type { IconName } from "../../components/ui/Icon";
import type { ListItemContentProps } from "../_base/types";
import type { AvatarColor } from "../shared/types";

const COLOR_CLASS: Readonly<Record<string, string>> = {
  orange: "bg-accent",
  blue: "bg-blue",
  green: "bg-green",
  red: "bg-red",
  purple: "bg-purple",
  pink: "bg-pink",
  gray: "bg-content-tertiary",
};

export function EpisodeChatItemContent({
  item,
}: ListItemContentProps): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const iconName = (item.metadata?.iconName as IconName) ?? "bot";
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const color = (item.metadata?.color as AvatarColor) ?? "orange";
  const bgClass = COLOR_CLASS[color] ?? "bg-accent";
  const time = item.metadata?.time as string | undefined;

  return (
    <>
      <div
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white ${bgClass}`}
      >
        <Icon name={iconName} size={16} />
      </div>
      <Stack gap={0.5} flex1>
        <Row justify="between">
          <Text variant="title" truncate as="span" className="list-item-title">
            {item.name ?? "Untitled"}
          </Text>
          {time ? (
            <Text variant="tiny" noShrink as="span" className="list-item-meta">
              {time}
            </Text>
          ) : null}
        </Row>
        {item.preview ? (
          <Text variant="caption" truncate className="list-item-secondary">
            {item.preview}
          </Text>
        ) : null}
      </Stack>
    </>
  );
}
